import script from "./UiForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UiForm.vue?vue&type=script&setup=true&lang=js"

import "./UiForm.vue?vue&type=style&index=0&id=379a8546&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379a8546"]])

export default __exports__